import lang from "element-ui/lib/locale/lang/en"; // 引入element语言包
const messages = {
  "极兔开放平台": "J & T  OPEN PLATFORM",
  帮助中心:"HELP",
  '注 册': "Register",
  "快递轨迹查询": "Tracking Query",
  "新增订单": "Create Order",
  "取消订单": "Cancel Order",
  "查询订单": "Check Order",
  "打印订单": "Waybill Model",
  "物流轨迹订阅（新）": "Logistics Tracking Subscription(New)",
  "物流轨迹回传": "Logistics Tracking Return",
  "订单状态回传": "Order Return Status",
  "退回件申请": "Return application",
  indexPage:{
    title:"Courier services docking technology platform",
    BannerTxt:"Sharing various service interfaces of J&T, realizing the integration of logistics supply chain, helping enterprises to efficiently complete express delivery, information tracking, and providing value-added services of express information security. Realize efficient cooperation with J&T.",
    BannerBtnTxt:"Join J & T open platform",
  },
  helpCenter:{
    "常用工具":"Common Tools",
    签名工具: "Signature tool",
    电子面单模板: "Electronic face sheet template",
    "API-SDK说明": "API-SDK description",
    签名方式:"Signature method",
    method_1:"1. Use the http protocol form submission method for information interaction, the character encoding is unified by UTF-8 by default, and the data format: application/x-www-form-urlencoded;",
    method_2:"2. apiAccount and privateKey are provided by the platform; digest=base64(md5 (Json+privateKey of business parameters)), note: first md5 gets the byte array, and then base64 encryption;",
    method_3:`3. For example: base64(MD5({"age":18,"gender":"male","name":"zhangsan"}123456)) If the signature is wrong, you can encode the URL and send the request.`,
    method_4:"4. Field type convention: development should be carried out in strict accordance with the parameter format and size given in the field table.",
    method_5:"5. Field resolution conventions: the required fields in the parameter fields are required to be passed in every time the interface is called;",
    method_6:"6. For part of the interface sample code and SDK, please refer to the sample code and SDK documentation.",
    业务参数签名:"Business parameter signature",
    请输入加密后的32位pwd:"Please input the 32-bit encrypted pwd",
    获取:"Get",
    Headers签名:"Headers signature",
    bussness:"Example: When calling the interface of placing an order, canceling an order, etc., the business parameter <code>digest</code> is required, and the business parameter <code>digest</code> has a different meaning from the <code>digest</code> in the global Headers.",

    bussness_1:`First of all, Jitu will assign an account and password required by the agreement customer to place an order. For example: <code>J0086024071</code>/<code>BaMCAx11</code>, where <code>pwd</code> is equal to <code>MD5 (plain text password (BaMCAx11)+jadada236t2)</code>
    After capitalization, for example, the 32-bit <code>pwd</code> generated by this example is <code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>, and finally the business parameter signature is generated according to the rule Base64 (Md5 (customer number + cipher text + privateKey)).`,
    bussness_2:`That is: business parameter signature <code>digest</code>=Base64(Md5(<code>J0086024071</code>+<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>+privateKey))`,
    headers_1:`Example: Take cancellation of an order as an example: suppose the business parameter is bizContent as <code>{"txlogisticId":"SA71398747473","orderType":2,"reason":"jiushixiangquxiaoyouruhe","customerCode":"J0086024071"} </code>, then the signature digest in the header at this time is equal to <code>base64(md5(Json+privateKey of business parameters))</code>,`,
    headers_2:`That is <code>base64(md5({"txlogisticId": "SA71398747473", "orderType": 2, "reason": "jiushixiangquxiaoyouruhe", "customerCode": "J0086024071", "digest": "4hQ8qXNkuSJ8cIgJQDFFRA=="}+privateKey))</code>.`,
    headers_3:`Note: <code>privateKey</code> is automatically assigned after the account is authenticated by the platform`,
    一联模版:"One-page template",
    "API开放平台-SDK":"Open API platform -SDK",
    "Introduction":"1.Introduction",
    "sdk_two":"2. Version update record",
    "sdk_3_title":"3. Quick Start Install API Open Platform SDK",
    "sdk_4_title":"4. API-SDK directory structure",
    "sdk_5_title":"5. JAR package directly following steps:",
    "sdk_6_title":"6. SDK related maven dependencies",
    "sdk_7_title":"7. Create JtExpressApi",
    "sdk_8_title":"8. Suggestion",
    "Introduction_1":"Hi, hello, and welcome to use the API open platform.",
    "Introduction_2":"This document is mainly aimed at platform developers and describes the relevant technical content of the express service technology docking platform. If you have any questions about the content of the document, you can contact the platform operation to answer the question.",
    date:"date",
    sdkVersion:"version number",
    updata:"Updates",
    updataInfo:"It provides a common interface standard to call an open platform, supporting the completion of the interface signature",
    "语言":"Language",
    最新版本:"Latest version",
    项目示例:"Project example",
    开发环境:"Development environment",
    "支持JAVA版本":"Support JAVA version: 1.8+",
    "支持PHP":"Support PHP7.0 and above",
    签名相关类:"Signature related classes",
    公用类:"Public class",
    异常相关类:"Exception related class",
    Http通信相关类:"Http communication related classes",
    开放平台api通用接口:"Open platform api general interface",
    执行器接口:"Actuator interface",
    "sdk_5_txt":`<p>1. The SDK compression toolkit is provided by the open platform. </p>
    <p>2. Unzip the "jt-openapi-sdk.zip" provided by the open platform and copy it to the project folder. </p>
    <p>3. Click File -> Project Structure (shortcut key Ctrl + Alt + Shift + s), click "Modules on the left side of the Project Structure interface.</p>
    <p>4. In the "Dependencies" tab interface, click the "+" sign on the right, select the first option "JARs or directories...", select the corresponding jar package, click "OK", the jar package is added successfully . </p>
    <p>5. The SDK calling method of the specific interface can be downloaded for reference. </p>`,
    sdk_6_txt:"SDK uses slf4j-api package for log output by default; SDK uses fastjson for json data conversion by default; SDK uses httpclient for http data transmission by default.",
    sdk_7_txt:`<p>JtExpressApi is the J&T open platform api general executor, which provides a series of interactive methods for developers who use the J&T open platform. </p>
    <p>Users can refer to the following code to create a new JtExpressApi. After the initialization is completed, it is recommended to use a singleton to avoid repeated creation:</p>`,
    sdk_8_txt:`<p>If you use the springboot framework to call API open platform-SDK related interfaces, it is recommended to put JtExpressApi in the spring container for management,</p>
    <p>Users can refer to the following code to create a new configuration class:</p>`,


  },
  controlPage:{
    "审核状态":"Review status",
    请选择国家: "Please select country",
    请输入酋长国: "Please enter city",
    请输入区域: "Please enter district",
    公司详细地址: "Company address",
    请输入社会信用代码: "Please enter license number",
    请上传营业执照: "Please upload image of business license",
    请输入法人身份证: "Please enter ID number of corporation",
    身份证详细地址: "ID address",
    请选择证件类型: "Please select a certificate type",
  },
  message: {},
  apiDoc: {
    极兔API简介: "Introduction to J&T API",
    订单服务: "Order Service",
    创建订单: "Create Order",
    查询订单: "Check Order",
    取消订单: "Cancel Order",
    订单状态回传: "Order Return Status",
    退回件申请: "Return application",
    '退换货接口': 'Return and exchange',
    散客寄件: "Individual shipment",
    物流轨迹: "Logistics Tracking",
    物流轨迹查询: "Logistics Tracking Query",
    '三段码查询': 'Three-segment code search',
    物流轨迹订阅: "Logistics Tracking Subscription",
    物流轨迹回传: "Logistics Tracking Return",
    API简介: "API introduction",
    IntroductionContent: "In order to have better service to our customers, J&T Open Platform provides a standardized and unified access API to directly realize data interaction between customers and the platform and improve the convenience of both parties. This platform will prove a detailed description of the accessing processes and steps to facilitate customers to access the API platform more quickly and accurately.",
    "对接流程": "Integration process",
    process_1: "1. Registration: To register as a member of J&T Open Platform.",
    process_2: "2. Application: Apply to be the developer and complete the developer information, then become a developer of J&T Open Platform.",
    process_3: "3. Enterprise Certification:  Complete the enterprise information to receive all the interface permissions like order service, electronic waybill service, etc.",
    process_4: "4. Joint Debugging and Testing: debugging test environment of API services, then to communicate with our API service personnel to solve problems.",
    process_5: "5. Publishment: After passing the joint debugging test, contacting our API service personnel to confirm the publishment details.",
    签名方式:"Signature method",
    method_1:"1. Use the http protocol form submission method for information interaction, the default character encoding form is UTF-8. Data format: application/x-www-form-urlencoded;",
    method_2:"2. apiAccount and privateKey are provided by the platform; digest=base64(md5 (Json+privateKey from the business parameters)), note: first md5 gets the byte array, and then encrypt by base64;",
    method_3:`3. For example: base64(MD5({"age":18,"gender":"male","name":"zhangsan"}123456)) If the signature is wrong, you can encode the URL and send the request.`,
    method_4:"4. Field type convention: development should be carried out in strict accordance with the parameter format and size given in the field table.",
    method_5:"5.  Field resolution conventions: the required fields in the parameter fields are required to be passed in every time the interface is called;",
    method_6:"6. For part of the interface sample code and SDK, please refer to the sample code and SDK documentation.",
    在线文档: "Online documentation",
    测试工具: "test tools",
    失败: "failure",
    Headers签名失败: "headers signature verification failed",
    内部调用异常: "Internal call exception",
    apiAccount为空: "apiAccount is empty!",
    digest为空: "digest is empty!",
    timestamp为空: "timestamp is empty!",
    系统错误: "System error",
    非法参数: "Illegal parameters",
    "面单模版查询": "Waybill Model",
    "其他服务": "Other services",
    "快件预报": "Shipping Forecast",
    "快件预报删除": "Shipment forecast deletion",
    "航空预报": "Aeronautical Forecast",
    '预估运费查询': 'Estimated freight query',
    "代收货款订阅": "Payment for goods subscription",
    "代收货款回传": "Receipt of payment for goods",
    "面单模版查询（新）": "Waybill Template Search (New)",
    "预约派送": "Rechedule Delivery",
    '出口国际件': 'Export international shipments',
    清关小包下发: "Delivery of Small Parcels After Customs Clearance",
    清关单下发: "Delivery of Customs Clearance Documents",
    清关单取消: "Cancellation of Customs Clearance Documents",
    清关单查询: "Customs Clearance Document Inquiry",
    清关服务: 'Customs Clearance Service'
  },
  onlineDoc: {
    地址: "Address: Use the URL provided by the access party",
    请求方法: "Request method:",
    数据类型: "type of data:",
    响应类型: "Response type:",
    接口说明: "Interface Description",
    接口信息: "Interface information",
    参数描述: "Parameter Description",
    Headers: "Headers",
    请求参数: "Request parameter",
    业务参数: "Business parameters",
    sender类型说明: "Sender type description",
    receiver类型说明: "Receiver type description",
    items类型说明: "Item type description",
    customsInfo类型说明: "CustomsInfo type description",
    details类型说明: "details type description",
    报文描述: "Message description",
    响应参数: "Response parameters",
    data类型说明: "Data type description",
    请求示例: "Request example",
    返回示例: "Return example",
    错误代码: "Error code",
    错误编码: "Error code",
    错误描述: "Error Description",
    测试地址: "Test address:",
    正式地址: "Official address:",
    测试apiAccount: "Test apiAccount:",
    测试privateKey: "Test privateKey:",
    属性名: "Parameter name",
    属性类型: "Parameter type",
    是否必填: "Is Mandatory",
    示例: "Example",
    描述: 'Description',
    OrderDescription_1: "Customers who have signed a contract with the platform can create/modify orders through this interface. The current order creation interface supports order modification, that is, if the customer order number (txlogisticId) already exists and the corresponding order has not been collected, directly modify the existing order. If the recipient address changes, get the latest three-segment code/big end return;",
    OrderDescription_2: "Query the order created by the new order interface",
    OrderDescription_3: "Cancel orders generated through the new order interface",
    OrderDescription_4: "After the access party has provided the logistics status to return relevant information and completed the order placement operation, when the order-related status changes, the system will actively push the logistics information according to the push account configured by the access party.",
    OrderDescription_5: `Non-office contract customers can create individual customer orders through this interface. At present, the individual customer shipping interface supports order modification, that is, if the customer order number (txlogisticId) already exists and the corresponding order has not been collected, the existing order will be directly modified. You can upload the sender's information through the "real-name information upload" interface;`,
    "通过单号查询快件的轨迹信息": "Query the track information of the shipment through the tracking number",
    OrderDescription_6: "Users can obtain template information of electronic sheet through the interface",
    OrderDescription_7: "Through the interface, the user can apply for returning the waybill that has been picked up",
    OrderDescription_8: "Get the three-segment code from sender's Add. and receiver's Add.",
    OrderDescription_9: "Return and Exchange Interface",
    trackDescription_1: "Query the track information of the shipment through the tracking number",
    trackDescription_2: `Subscribe to Polar Rabbit to push the waybill number of the logistics track <br/> <strong>Note: Need to provide the URL of the return logistics track</strong> `,
    trackDescription_2_1: `Subscribe to Polar Rabbit to push the waybill number of the logistics track, Note: Need to provide the URL of the return logistics track`,
    trackDescription_3: "After the access party has provided the delivery track push related information and completed the order placement operation, when the order-related waybill track changes, the system will actively push the logistics information according to the push account configured by the access party.",
    // 表单描述翻译
    接入方在平台的api账户标识: "The third party's account use to access the platform",
    通过地址查询对应的三段码信息:"Get the three-segment code from sender's Add. and receiver's Add.",
    签名字符串: "Signature string",
    "时间戳，毫秒": "Timestamp, milliseconds",
    业务参数模块内json格式的string类型: "The string type in json format in the business parameter module",
    "客户编码（联系出货网点提供）": "Customer code (Proved by origin station)",
    sign: "Signature, Base64 (Md5 (customer number + cipher text + privateKey)), where the cipher text: MD5 (plain text password + jadada236t2) followed by uppercase",
    signnew: "1. MD5 signature, Base64(Md5(customer number+ciphertext+privateKey)), where ciphertext: MD5 (plaintext password+jadada236t2) followed by uppercase <br />2. SHA256 signature, Sha256 (customer number + ciphertext + privateKey), where ciphertext: Sha256 (plaintext password)",
    合作网点: "Cooperation outlets",
    "客户订单号（传客户自己系统的订单号）": "Customer order number (pass the order number of the customer’s own system)",
    ExpressType: "Express types:<br/> EZ：standard（UAE)；<br/>EZKSA：standard（KSA)；<br/>Reverse: Reverse（KSA）；<br/>ReverseUAE: Reverse（UAE）<br/>SDD:Same Day（KSA）<br/>SDDUAE:Same Day（UAE）<br/>SCH: SCHEDULE（KSA）<br/>SCHUAE: SCHEDULE（UAE）",
    expressQueryType: "0.Express Side Sheet Template <br/>1. Cross-Border Parts Single Template<br/>2. Export international parcel waybill template",
    OrderType: "Order type (customer number is monthly settlement) 1. Individual customers; 2. Monthly settlement;",
    OrderTypeSec: "Order type (customer number is monthly settlement) 1. Individual customers; 2. Monthly settlement; 3. Export international shipment;",
    服务类型: "Type of service: <br /> 02 store delivery <br /> 01 pick up at door",
    serviceTypeCode: 'C01: International <br/>C02: Domestic',
    "派送类型": "Delivery type: <br />03 Self pickup；<br />04 Deliver to door",
    paymentMethod: `Payment method: PP_PM ("Monthly payment by shipper")`,
    寄件信息对象: "Shipment information object",
    收件信息对象: "Receiving information object",
    LC_pick_up_start_time: "Appointed pick up time, starts at yyyy-MM-dd HH:mm:ss",
    CLC_door_to_door_end_time: "Appointed pick up time, ends at yyyy-MM-dd HH:mm:ss",
    itemtType: "Item type (Match to the Item type on the waybill): <p>ITN1 Clothes</p>  <p>ITN2 Document</p>  <p>ITN3 Food</p>  <p>ITN4  others</p>  <p>ITN5  Digital product</p>  <p>ITN6  Daily necessities</p>  <p>ITN7 Fragile Items</p>",
    Length: "Length, cm",
    Width: "Width, cm",
    Height: "Height, cm",
    volume: "volume",
    Weight: "Weight, unit kg, range 0.01-30",
    "包裹总件数": "Total number of packages",
    "包裹总票数": "Total number of tickets for the package (<=999)",
    "代收货款金额 (数值型)": "COD amount (numeric)",
    "代收货款金额 (数值型)1": "COD amount (Condition is required,numeric)",
    collectionPayment: "COD currency",
    collectionPayment1: "COD currency (Condition is required)",
    offerFee: "Insurance amount (numeric type), unit, such as SAR, AED, USD, RMB, (0~99999999, supports 4 decimal places)",
    "保价费": "Insurance fee",
    "备注": "Remark",
    "商品信息列表": "Product information list",
    "客户信息": "Customer Information",
    "寄件人姓名": "Sender name",
    "卖家ID": "Seller ID",
    "寄件公司": "Sender company",
    "寄件邮编": "Sender zip code",
    "寄件邮箱": "Sender mailbox",
    SendingMobilePhone: "Sender mobile phone (required to fill in mobile phone or telephone）",
    SendingPhoneNumber: "Sender telephone (required to fill in mobile phone or telephone)",
    ThreeCharacterSending: "Three-character country code of sender country (eg UAE=UAE, China=CHN, KSA=KSA)",
    "寄件酋长国": "Sender province",
    "寄件区域": "Sender city",
    "区域1": "Sender area",
    "寄件街道": "Sender street",
    ShippingDetailedAddress: "Sender detailed address (Emirate + area + street + detailed address)",
    "寄件区号": "Sender area code",
    "收件人姓名": "The recipient's name",
    "收件人证件号码": "Recipient ID numbers",
    "收件公司": "receiver",
    "收件邮编": "Receiver postal code",
    "收件邮箱": "Receiver mailbox",
    ReceivingMobilephone: "Receiver mobile phone (required to fill in mobile phone or telephone)",
    ReceivingPhoneNumber: "Receiver telephone (required to fill in mobile phone or telephone)",
    ThreeCharacterRecipient: "Three-character code of receiver country (eg UAE=UAE, China=CHN, KSA=KSA) <p>The delivery address must be consistent with the custonher's location</p>",
    "收件酋长国": "Receiver Province",
    "收件区域": "Receiver City",
    "区域2": "Receiver Area",
    "收件街道": "Receiver street",
    ReceivingDetailedAddress: "Receiver detailed address (Province + city + street + detailed address)",
    "收件区号": "Receiver area code",
    物品类型: "Item type:<p>ITN1 Clothes</p>  <p>ITN2 Document</p>  <p>ITN3 Food</p>  <p>ITN4  others</p>  <p>ITN5  Digital product</p>  <p>ITN6  Daily necessities</p>  <p>ITN7 Fragile Items</p>",
    "物品名称": "Item Name",
    "物品中文名称": "Chinese name of the item",
    "物品英文名称": "English name of the item",
    cases: "Number of cases, ≤ 1",
    "申报价值(数值型)": "Declared value (numerical type), The value of a single item",
    priceCurrency: "Declare the payment currency (default domestic currency, such as: AED), The declared currency of a single order cannot be inconsistent",
    "物品描述": "item description",
    '退换货': '1: Return </br > 2: return and exchange',
    '退货单单号': 'Return order No',
    '换货单单号': "Replacement Order No (Returns when returnandexchangetype is 2)",
    "商品URL": "Product URL",
    "货物数量 跨境件报关需要填写": "The quantity of goods needs to be filled in for cross-border customs declaration",
    货物单位: "Cargo unit, such as: pieces and set, cross-border cargo declaration needs to be filled in",
    原产地国别: "Country of origin of the product, cross-border customs declaration needs to be filled in",
    货物产品国检备案编号: "National inspection record number of goods and products, cross-border customs declaration needs to be filled in",
    商品海关备案号: "Commodity customs record number",
    商品行邮税号: "Commodity postal tax number is required for cross-border customs declaration",
    海关编码: "Customs code is required for cross-border customs declaration",
    商品编号: "Commodity No. Cross-border customs declaration needs to be filled in",
    货物品牌: "Cargo brand cross-border customs declaration needs to be filled in",
    货物规格型号: "Cargo specifications and models, cross-border cargo declarations need to be filled in",
    生产厂家: "Manufacturers need to fill in cross-border customs declaration",
    托寄物声明价值: "The declared value of the consignment is required for cross-border customs declaration",
    托寄物声明价值币别: "Consignment declared value currency, cross-border customs declaration needs to be filled in",
    客户支付的运费: "Amount of shippment fee paid is required for cross-border customs declaration",
    "返回码，见附录": "Return code, see appendix",
    "业务数据": "Business data",
    "集包地": "Collection land",
    "返回客户订单号": "Return customer order number",
    订单创建时间: "Order creation time yyyy-MM-dd HH:mm:ss",
    "三段码online": "Three-segment code (get the three-segment code first to return to the three-segment code, if there is no three-segment code, return to the big pen)",
    "参考总运费": "Refer to the total freight (numerical type)",
    "查询命令": "Query command 1. Query by customer order number 2. Query by waybill number (check order status with waybill number) 3. Query by time period of order (check order) (query by time period returns unlimited number) 4. Order serial number",
    command: "ccommand=1 customer order number query; command=2 waybill number temporarily; command=4 order number (internal company) supports 200; Command=1, 2 or 3 is required",
    startDate: "Start time (24 hour system: yyyy-MM-dd HH:mm:ss Required when command is 3) Order Time (Required when Command = 3)",
    endDate: "End Time (24 hour system: yyyy-MM-dd HH:mm:ss Required when command is 3) Time Range (7 days at the most, Required when Command = 3)",
    status: "Status (the order status is taken from the status table below, filtered data is used, all by default): canceled 104: picked up 103: dispatched salesperson    102: dispatched outlets 101: not dispatched 100",
    "command = 3 时必填": "Required when command = 3",
    系统订单号: "System order number",
    "客户订单号-客户自己系统的订单号": "Customer order number (The order number of the customer's own system)",
    "快件类型": `Express type: only supports "standard, express`,
    订单状态: "Order status: <br />104: Cancelled;<br /> 103: Picked up;<br /> 102: Arranged Operator; <br /> 101: Arrange Operation Station;<br /> 100: No Arrangement",
    订单类型: "Order type: 01 individual customers 02 month settlement",
    三段码: "Three-segment code",
    "客户编码（订单类型传2时，必填）": "Customer code (Proved by origin station)",
    "订单类型  1（散客），2（协议客户），3（出口国际件）": "Order type <br />1: individual customers <br />2: contract customers <br />3: Export international shipment",
    "取消原因": "Reason for Cancellation",
    "退件原因": "Return reason",
    "运单号": "Waybill number",
    "更新订单时，必传": "When updating the order, it must be passed",
    "客户订单号": "customer order no",
    operateType: `In the event, the customer fills in "Add" to add an order; if the customer submits "Update", then an order is updated.<p>1 Adding</p><p>2 Modifying</p>`,
    客户订单编号: "Customer order number",
    极兔运单编号: "J&T Waybill Number",
    "网点名称（“已调派业务员”回传）": `Station Name (Returned by Assgined Courier)`,
    "业务员名称（“已调派业务员”回传）": `Courier Name (Returned by Assgined Courie)`,
    "业务员联系方式（“已调派业务员”回传）": `Courier Cantact Infomation (Returned by Assgined Courie)`,
    极兔订单编号: "J&T Order Number",
    "重量（“已揽收”“已取件”时回传）": `Weight (Returned when collected or picked up)`,
    "订单取消原因（“已取消”时回传）": `Reason for order cancellation (Returned when collected or picked)`,
    "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)": `Status ("Courier Assigned", "Collected", "Picked up", "Cancelled")`,
    "时间": "time",
    承运商编码: "Carrier code",
    "业务员编码（联系出货网点提供，且采用网点编码签名）": "Salesman code (provided by contacting the shipping outlet, and signed by the outlet code)",
    "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写": "Signature, Base64 (Md5 (customer code/salesman code+ciphertext+privateKey)), where the ciphertext: MD5 (plaintext password/point code+jadada236t2) followed by capital",
    运单编号: "Waybill number",
    "快件类型：EZ(标准快递)": "Express type: EZ (standard express)",
    "订单类型  1、散客；": "Order type 1. Individual customers;",
    "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）": `Payment method CC_CASH ("Pay and cash settlement"); PP_CASH ("Pay and cash settlement")`,
    "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss": "The end time of the logistics company's pick-up yyyy-MM-dd HH:mm:ss",
    "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单": "Waybill number. Multiple waybill numbers are separated by English commas. Currently, it supports querying up to 30 waybills at one time.",
    运单轨迹详情: "Waybill track details",
    扫描时间: "Scan time",
    轨迹描述:  "Transition Description",
    scanType: "Scan type : <p>10：Pickup scan</p> <p>50：Station sending/DC sending</p> <p>92：Station arrival</p> <p>90：DC arrival</p><p>94：Delivery scan</p><p>100：Sign scan</p><p>110：Abnormal parcel scan</p><p>172：Returned parcel scan</p><p>402：Change Address scan</p> <p>1001:Returned signed</p> <p>301: International warehousing</p> <p>302: International Air Arrival</p> <p>303: International Air Shipment</p> <p>304: Customs declaration scan</p> <p>305: Customs clearance scan</p>",
    scanTypeCode: "Scan type code",
    扫描网点名称: "Scan Station name",
    扫描网点ID: "Scan Station ID",
    业务员姓名: "Courier Name",
    业务员联系方式: "Courier contact information",
    扫描网点联系方式: "Contact Information of Scan Station",
    扫描网点省份: "Scan Province",
    扫描网点城市: "Scan City",
    "扫描网点区/县": "Scan area",
    "上一站(到件)或下一站名称(发件)": "Last stop (arrival) or next stop name (sent)",
    "下一站省份（发件扫描类型时提供）": "Next stop Province (provided when sending scan type)",
    "下一站城市（发件扫描类型时提供）": "Next stop city (provided when sending scan type)",
    "下一站区/县（发件扫描类型时提供）": "Next stop district/county (provided when sending scan type)",
    "签收图片（签收扫描时，展示该数据）":"Sign in picture (show the data when signing in for scanning)",
    "电子签名（签收扫描时，展示该数据）":"Electronic signature (show the data when signing in for scanning)",
    快递轨迹详情: "Courier tracking details",
    "订阅节点": "Subscription node: <br />10&50&92&90&94&100&110&172&402&1001&301&302&303&304&305  <p>10：Pickup scan</p> <p>50：Station sending/DC sending</p> <p>92：Station arrival</p> <p>90：DC arrival</p><p>94：Delivery scan</p><p>100：Sign scan</p><p>110：Abnormal parcel scan</p><p>172：Returned parcel scan</p><p>402：Change Address scan</p> <p>1001: Returned signed</p> <p>301: International warehousing</p> <p>302: International Air Arrival</p> <p>303: International Air Shipment</p> <p>304: Customs declaration scan</p> <p>305: Customs clearance scan</p>",
    数组: "Array",
    "明文密码:H5CD3zE6": "Clear text password: H5CD3zE6",
    "电子面单标签": "Electronic surface single label",
    "电子面单链接": "Electronic surface single url",
    "平台名称":"Platform",
    "客户账户": "Customer Account",
    isUnpackEnabled: "Allow customer to open the box for inspection<p>0 no</p><p>1 yes</p>",
    needLogo:'0: yes; <br />1: no',
    寄件经度: 'Sender Longitude',
    寄件纬度: 'Sender Latitude',
    收件经度: 'Receiver Longitude',
    收件纬度: 'Receiver Latitude',
    "经度（在问题件扫描时回传）": 'Longitude (returned when the problem piece is scanned)',
    "纬度（在问题件扫描时回传）": 'Latitude  (returned when the problem piece is scanned)',
    "OTP验证码（签收扫描类型时提供）": 'OTP verification code (provided when signing for scan type)',
    '商户号': 'Business Number',
    "快件预报接口": "It is used for cross-border customers to synchronize shipment information in shipment batches, such as MAWB/RAWB, package number, and shipment order number information. After the shipments are sorted, packed and weighed, and booked by air/load in the warehouse area, the information of the shipments in the relevant batches is returned through the interface.",
    "航空主单号": "MAWB",
    "托盘号": "pallet No",
    "包号": "package No",
    "包重量": "Packge Weight",
    "封包时间": "Closing Time",
    "包列表": "Packge list",
    "航空预报接口": "It is used for cross-border customers to synchronize air, land and sea information of shipment batches. After completing the booking and obtaining the carrier's flight information, the terminal J&T Express is synchronized through the interface, which is convenient for the terminal to arrange customs clearance and LastMile delivery.",
    "航空主单号陆运主单号": "MAWB",
    "航班号": "Flight No",
    "航班日期": "Flight Date",
    "航班预计起飞时间": "ETD",
    "航班预计到达时间": "ETA",
    "航班实际起飞时间": "Actual Flight Departure Time",
    "航班实际到达时间": "Actual Flight Arrival Time",
    "运送重量": "Shipping Weight",
    "起始地国家": "Origin Country <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    "目的地国家": "Destination Country <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    "起始地机场": "Departure Airport",
    "目的地机场": "Destination Airport",
    "目的港": "Destination Port <br /> DMM <br /> JED <br /> RUH <br />DXB",
    "删除类型": "delete type <br /> PALLET：pallet <br /> PACKAGE_INFO ：package information <br /> ORDER：order",
    "批次号（快件预报删除）": "batch number（type includes PALLET 、PACKAGE_INFO required）",
    "托盘号（快件预报删除）": "PALLET number（type includes PALLET、PACKAGE_INFO required）",
    "包号（快件预报删除）": "package number（type includes PACKAGE_INFO required）",
    "运单号（快件预报删除）": "Waybill number（type includes ORDER required）",
    "快件预报删除接口": "Use this interface to delete the information submitted in the shipment forecast",
    "托盘列表": "pallet list",
    "订单列表": "Order List",
    签名类型: 'Signature type 1.MD5(default) 2.SHA256',
    "问题件图片（在问题件扫描时提供）": "Picture of the problem part (provided when the problem part is scanned)",
    "问题件二级编码": 'Problem piece secondary code',
    '预估运费查询': 'Estimated freight query',
    '预估运费查询说明': 'Estimate the freight through the mailing address and item information',
    '⻓，cm': 'long，cm',
    '宽，cm': 'wide，cm',
    '⾼，cm': 'height，cm',
    '重量': 'Weight (positive number), unit: kg, range: 0.01-30, default: 0.02',
    '运费总价（单位：元），保留两位⼩数': 'Total freight price (unit: yuan), two digits reserved',
    "subscribeDesc": "The customer code of the open platform customer who needs to receive the payment for goods according to the subscription requirements of apiaccount",
    "subscribeOtherDesc": "Push the payment for goods collected by financial settlement to the customer. The customer needs to configure the return address on the open platform.",
    '登记时间': 'Registration time',
    '订单流水号': 'Order serial number',
    '返款进度': 'Repayment progress\n1:Pending application\n2:To be reviewed\n3:Payment to be refunded\n4:Refund',
    '应付客户货款⾦额': 'Amount payable to customers',
    '总运单票数': 'Total number of waybill tickets',
    '运单列表信息': 'Waybill list information',
    "到件图片（到件扫描时，展示该数据，多张图片以逗号分割）": "Incoming picture (when the incoming picture is scanned, the data is displayed, multiple pictures are separated by commas)",
    "预约派送日期": "Scheduled delivery date",
    "预约派送时间段": "Scheduled delivery time",
    "国家三字码": "country code",
    "省份": "province",
    "城市": "City",
    "区域": "area",
    "详细地址": "Address",
    "true 成功 false 失败": "true success false failure",
    "客户可通过此接口进行预约派送": "Customers can schedule delivery through this API",
    OrderDescription_10: "Customers who have signed contracts with the platform can create export international express orders through this interface.",
    '业务参数，各接口的入参json报文': 'Business parameters, input parameter JSON messages for each interface.',
    '默认C03-出国国际件': 'Default: C03 - Export International Shipments',
    CharacterSending: "Sender country 2/3-letter code (UAE = AE/UAE) – only UAE is supported.",
    CharacterRecipient: "Two-letter code of the recipient's country",
    '数量': 'number',
    'purposeOfShipment': 'Shipping purpose (e.g., 1, 2, 3)<br/>1 corresponds to Gift<br/>2 corresponds to Personal not for sale<br/>3 corresponds to General Items',
    '原产地': 'country of origin',
    internationalExportExpressType: 'Shipment type: only supports ExportUAE',
    寄件建筑物编号: 'Sender building number',
    寄件辅助编号: 'Sender secondary number',
    寄件短地址: 'shortAddress(Field is mandatory: when the destination country is SA or KSA, the short address must be filled in)',
    收件建筑物编号: 'Receiver building number',
    收件辅助编号: 'Receiver secondary number',
    收件短地址: 'shortAddress(Field is mandatory: when the receiver country is SA or KSA, the short address must be filled in)',
    '清关服务': 'Customs Clearance Service',
    '清关小包下发': 'Delivery of Small Parcels After Customs Clearance',
    '下发清关小包信息接口（运单号需要先从订单创建接口获取）': 'API for Issuing Small Parcel Customs Clearance Information (the tracking number must be obtained from the create order API first)',
    '客户订单号（包裹号）': 'Customer Order Number (Package Number)',
    '收件人名称': "Recipient's Name",
    '收件国家': "Recipient's Country",
    '收件人详细地址': "Recipient's Detailed Address",
    '收件人手机号': "Recipient's phone number",
    '收件人电话': "Recipient's Phone Number",
    '收件人ID信息': "Recipient's ID Information",
    '收件人ID有效截止日期': "Recipient's ID Expiry Date",
    '收件人生日': "Recipient's Birthday",
    '收件人国籍': "Recipient's Nationality",
    '寄件人名称': "Sender's Name",
    '寄件国家': "Sender's Country",
    '寄件人详细地址': "Sender's Detailed Address",
    '寄件人手机号': "Sender's Mobile Phone Number",
    '寄件人电话': "Sender's Phone Number",
    '寄件公司（高价值必填）': "Sender's Company (Required for High-value Shipments)",
    '申报币种': 'Declared Currency',
    '包裹重量': 'Parcel Weight',
    '物品明细': 'Item Details',
    '物品单价': 'Unit Price of the Item',
    '物品单重（单个物品的重量）': 'Unit Weight of the Item (Weight of a Single Item)',
    '海关申报编码': 'Customs Declaration Code',
    '类目id': 'Category ID',
    'sku': 'sku',
    '操作结果,1请求成功，0失败': 'Operation Result: 1 for Success, 0 for Failure',
    '错误码': 'Error Code',
    '清关单下发': 'Delivery of Customs Clearance Documents',
    '下发清关单相关信息': 'Release Relevant Information on Customs Clearance Documents',
    '提单号': 'Bill of Lading Number',
    '关务提单号': 'Customs Bill of Lading Number',
    '运输工具代码': 'Conveyance Code',
    '始发地港口代码': 'Port of Departure Code',
    '目的地港口代码': 'Port of Destination Code',
    '始发地城市代码': 'City of Departure Code',
    '目的地城市代码': 'City of Destination Code',
    '目的地国家代码': ' Destination Country Code',
    '预计离开时间': 'Estimated Departure Time (EDT)',
    '预计抵达时间': 'Estimated Arrival Time (EAT)',
    '箱数': 'Number of Containers/Cases',
    '提单扫描件': 'Scanned Copy of Bill of Lading',
    '关系list': 'Relationship List',
    '大包号': 'Master Parcel Number',
    '小包号': 'Sub-parcel Number',
    '清关单取消': 'Cancellation of Customs Clearance Documents',
    '取消申报清关单，申报开始前支持取消': 'Cancel the declaration of customs clearance documents; cancellation is supported before the start of the declaration.',
    '清关单查询': 'Customs Clearance Document Inquiry',
    '支持查询清关单对应的提单状态及小包(运单)状态信息': 'It supports querying the bill of lading status corresponding to the customs clearance document as well as the status information of sub-parcels (waybills).',
    '业务数据（提单号、运单号、大包号）': 'Business Data (Bill of Lading Number, Waybill Number, Master Parcel Number)',
    '提单状态code': 'Bill of Lading Status Code',
    '提单状态': 'Bill of Lading Status',
    '大包对象集合': 'Master Parcel Object Collection',
    '大包对象说明<BillLadingRelationVO>': 'Description of Master Parcel Object<BillLadingRelationVO>',
    '小包集合': 'Sub-parcel Collection',
    '小包对象说明<CustomsPackageRelationVO>': 'Description of Sub-parcel Object <CustomsPackageRelationVO>',
    '运单状态code': 'Waybill Status Code',
    '运单状态': 'Waybill Status',
    "业务枚举": "Business Enumeration ：<br/>1 represents Bill of Lading Number; 2 represents Master Parcel Number; 3 represents Waybill Number",
    '时间戳': 'Timestamp',
    '客户编码': 'Customer Code',
    '默认：AIR_TRANSPORT': 'Default: AIR_TRANSPORT',
    "目的地国家代码KSA": "KSA 、 UAE 、 JOR 、 KWT",
    PDF的base64格式: 'Base64 format of the PDF',
    itemList类型说明: 'ItemList type description',
    tiesList类型说明: 'TiesList type description',
    返回码: 'Return Code'
  },
  apiTestDoc: {
    接口说明: "Interface Description",
    Headers: "Headers",
    Body: "Body",
    Response: "Response",
    错误代码: "Error code",
    错误编码: "Error code",
    错误描述: "Error Description",
    请求头Headers参数: "Request Headers parameters",
    不能为空: "can not be empty",
    参数: "parameter",
    业务参数签名失败: "Business parameter signature verification failed",
    修改订单失败: "Order modification failed",
    区域不合法: "Illegal region",
    城市不合法: "Illegal city",
    省份不合法: "Illegal province",
    查不到数据: "Data not found",
    下单失败: "Order placement failed",
    发件人信息不全: "Incomplete sender information",
    "订单重复,无需重复下单！": "Duplicate order, don't place the order repeatedly!",
    收件人信息不全: "Incomplete recipient information",
    电话号码不能为空: "Phone number cannot be empty",
    地址信息不全: "Incomplete address information",
    "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法": "Please check whether the order type, service type, delivery type, item type, shipment type and settlement method are legal",
    "请检查服务类型是否合法值为 01或 02": "Please check if the service type is legal with the value of 01 or 02",
    上门服务时间信息不全: "Incomplete service time information",
    重量信息不合法: "The weight information is not legal",
    物品信息不全: "Incomplete item information",
    物品名称不全: "Incomplete item name",
    物品类型不全: "Incomplete item type",
    "客户订单号已存在,无法下单！": "Customer order number already exists, cannot place an order!",
    姓名信息非法: "Illegal name information",
    公司信息过长: "Company information is too long",
    联系信息过长: "Contact information is too long",
    邮编或邮箱信息非法: "Postcode or email address is illegal",
    价格信息非法: "Price information is illegal",
    "备注、描述、链接信息非法": "Comments, descriptions, links are illegal",
    地址信息过长: "Too much address information",
    街道信息过长: "Street information is too long",
    包裹总件数无效: "The total number of parcels is invalid",
    暂未开通代收货款业务: "COD service is not opened",
    "支付方式不匹配,PP_CASH,CC_CASH,PP_MM": "The payment method does not match,PP_CASH,CC_CASH,PP_MM",
    "已取件状态不可修改": "Picked up status can not be modified",
    "已取消状态不可修改": "Cancelled status can not be modified",
    "更新订单失败，请稍后重试！": "Updating order failed, please try again later!",
    "始发地信息不全": "Incomplete information of origin",
    "收货地信息不全": "Incomplete information of receiving place",
    "暂未开通保价服务": "The insurance service is not yet available",
    "保价金额需大于等于0": "The insured amount must be greater than or equal to 0",
    "时间范围非法": "Illegal time range",
    "页码非法": "Illegal page number",
    "超过数据限制": "Data limit exceeded",
    "客户订单号不能为空或过长": "Customer order number cannot be empty or too long",
    "取消原因不能为空": "Cancellation reason cannot be empty",
    运单号非法: "Illegal waybill number",
    运单号个数超过30: "The quantity of the waybill number exceeds 30",
    运单号个数超过1000: "The quantity of the waybill number exceeds 1000",
    物品数量非法: "Illegal item quantity",
    非法金额: "Illegal amount",
    "必填参数为空": "Required parameter is empty",
    '总数量不能超过 999': 'totalQuantity cannot exceed 999',
    '客户编码不合法': 'Customer code is illegal',
    '发件人信息不完整': 'Incomplete sender information',
    '收件人信息不完整': 'Incomplete receiver information',
    '手机号码长度错误': 'MOBILE_LENGTH_ERROR',
    '请填写正确的寄件省份': 'Please fill in the correct sending prov',
    'COD代收货款不能超过3万': 'The COD(collection on delivery) cannot be greater than 30000',
    '货到付款金额不能小于': 'The COD(collection on delivery) cannot be less than 0.01',
    '货品类型信息不完整': 'Incomplete item type',
    '请检查服务类型是否合法（仅支持 01 或 02）': 'Please check if the service type is legal with the value of 01 or 02',
    '请填写正确的派送类型': 'Please fill in the correct delivery type',
    '请填写正确的运输类型': 'Please fill in the correct shipment type',
    '快递类型错误': 'Express type error',
    '服务类型代码校验失败': 'ServiceTypeCode validation failed',
    '仓库标识错误': 'isWarehouse error',
    '条码不能为空': 'barcode cannot be empty',
    '商品编码不能为空': 'item_code cannot be empty',
    'SKU 编码不能为空': 'sku_code cannot be empty',
    '参数长度超过最大限制': 'The parameter length exceeds the maximum limit',
    '运费不能小于 0': 'The OfferFee cannot be lessthan 0',
    '运费不合法': 'The offerFee is invalid',
    '收货地址与客户所在位置不一致': 'The delivery address does not match the customer is location',
    '未找到收件人国家': 'Recipient country not found',
    '币种不合法': 'Invalid currency',
    '订单申报币种不匹配': 'Order declaration currency mismatch',
    '寄件国家编码或者名称不能为空': '%s can not be empty',
    '高价值包裹必须填写收件人证件号码': 'High-value packages must fill in the receiveridNumber',
    '订单申报币种': 'Order declaration currency',
    '货物寄送目的填写错误': 'The purpose of shipment is filled in incorrectly'
  },
  ...lang,
};

export default messages;
